import events from '../events';
import { session, socket } from './session';
import { _$, _hide, _removeModals, _setText, _spinner } from './dom';
import { NotificationManager } from 'react-notifications';
import { locales } from '../translations/locales';
import { readCookie } from './cookies';
/**
 * MOD RP
 * @override
 */
class Module {
    /**
     * Init module param
     */
    constructor() {
        this.version = '0.1.2',
            this.isValide = false;
        this.socket = false;
        this.session = false;
        this.setUpdate = null;
        this.userName = null;
        this.userId = null;
        this.page = 'Logo';
        this.setData = null;
        this.lobbyText = false;
        this.waitForValidSession();
        this.locale = readCookie('lang');
        this.formatCharacter = /[!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>/?]+/;
        this.gameId = null;
        this.configActive = 'Dashboard';
        this.gameData = null;
        this.dataVehicle = null;
        this.listStatus = null;
        this.planningStatus = [
            { id: 'onDuty', etat: 1, color: '#e0000b' },
            { id: 'onCall', etat: 2, color: '#007be0' },
            { id: 'available', etat: 3, color: '#0be000' },
            { id: 'unspecified', etat: 4, color: '#5E5A52' },
        ];
        this.activeMission = null;
        this.alarm = new Audio('/sounds/reception.ogg');
        this.alarm.volume = 0.1;
        this.setAlert = null;
    }

    Bip = null;
    Radio = null;

    config = {
        infos: () => {
            const name = _$('gameName').value;
            const description = _$('gameDescription').value;
            _spinner('btn-confirm-update-infos');
            this.socket.emit(events.CONFIGURE_UPDATE, this.gameId, ['name', 'description'], [name, description]);
        },
        access: (isPublic, recruitmentOpen) => {
            _spinner('btn-confirm-update-access');
            this.socket.emit(events.CONFIGURE_UPDATE, this.gameId, ['isPublic', 'recruitmentOpen'], [isPublic, recruitmentOpen]);
        },
        deleteGame: () => {
            _spinner('btn-delete-game');
            this.socket.emit(events.DELETE_GAME, this.gameId);
        },
        deletePlayer: (playerId) => {
            // _spinner('btn-deletePlayer' + playerId);
            this.socket.emit(events.DELETE_PLAYER, this.gameId, playerId);
        },
        managePlayer: (playerId) => {
            this.socket.emit(events.MANAGE_PLAYER, this.gameId, playerId);
        },
        updatePlayer: (playerId, params, values) => {
            _spinner('btn-confirm-update-player' + playerId);
            this.socket.emit(events.EDIT_PLAYER, this.gameId, playerId, params, values);
        },
        refusePlayer: (playerId) => {
            _spinner('btn-refusePlayer-' + playerId);
            _hide('btn-acceptPlayer-' + playerId);
            this.socket.emit(events.REFUSE_NEW_PLAYER, this.gameId, playerId);
        },
        acceptPlayer: (playerId) => {
            _spinner('btn-acceptPlayer-' + playerId);
            _hide('btn-refusePlayer-' + playerId);
            this.socket.emit(events.ACCEPT_NEW_PLAYER, this.gameId, playerId);
        },
        newBuilding: (lngLat) => {
            _spinner('btn-newBuilding');
            const newBuilding = {
                name: _$('buildingName').value,
                address: _$('buildingAddress').value,
                lngLat: lngLat || { lng: 0, lat: 0 },
            };
            this.socket.emit(events.NEW_BUILDING, this.gameId, newBuilding);
        },
        manageBuilding: (buildingId) => {
            this.socket.emit(events.MANAGE_BUILDING, this.gameId, buildingId);
        },
        updateBuilding: (params, values) => {
            _spinner('btn-confirm-update-building');
            this.socket.emit(events.EDIT_BUILDING, this.gameId, params, values);
        },
        deleteBuilding: (buildingId) => {
            _spinner('btn-delete-building');
            this.socket.emit(events.DELETE_BUILDING, this.gameId, buildingId);
            this.configActive = 'NewBuilding';
        },
        updateVehicleInBuilding: (buildingId, vehicleId, params, values) => {
            _spinner('btn-updateVehicleInBuilding');
            this.socket.emit(events.EDIT_VEHICLE_IN_BUILDING, this.gameId, buildingId, vehicleId, params, values);
            this.configActive = 'ManageBuilding';
        },
        addVehicleInBuilding: (buildingId, vehicle) => {
            _spinner('btn-addVehicleInBuilding');
            this.socket.emit(events.ADD_VEHICLE_IN_BUILDING, this.gameId, buildingId, vehicle);
        },
        manageVehicleInBuilding: (vehicle) => {
            this.dataVehicle = vehicle;
        },
        deleteVehicleInBuilding: (buildingId, vehicleId) => {
            _spinner('btn-delete-vehicleInBuilding');
            this.socket.emit(events.DELETE_VEHICLE_IN_BUILDING, this.gameId, buildingId, vehicleId);
            this.configActive = 'ManageBuilding';
        },
        newVehicleModel: (vehicleModelFunctions) => {
            _spinner('btn-newVehicleModel');
            this.socket.emit(events.NEW_VEHICLE_MODEL, this.gameId, { name: _$('vehicleModelName').value, functions: vehicleModelFunctions });
        },
        manageVehicleModel: (vehicleModelId) => {
            this.socket.emit(events.MANAGE_VEHICLE_MODEL, this.gameId, vehicleModelId);
        },
        updateVehicleModel: (params, values) => {
            _spinner('btn-confirm-update-vehicleModel');
            this.socket.emit(events.EDIT_VEHICLE_MODEL, this.gameId, params, values);
        },
        deleteVehicleModel: (vehicleModelId) => {
            _spinner('btn-delete-vehicleModel');
            this.socket.emit(events.DELETE_VEHICLE_MODEL, this.gameId, vehicleModelId);
            this.configActive = 'NewVehicleModel';
        },
        newSkill: (skillName) => {
            _spinner('btn-newSkill');
            this.socket.emit(events.NEW_SKILL, this.gameId, skillName);
            this.configActive = 'NewSkills';
        },
        manageSkill: (skillId) => {
            this.socket.emit(events.MANAGE_SKILL, this.gameId, skillId);
        },
        updateSkill: (params, values) => {
            _spinner('btn-confirm-update-skill');
            this.socket.emit(events.EDIT_SKILL, this.gameId, params, values);
        },
        deleteSkill: (skillId) => {
            _spinner('btn-delete-skill');
            this.socket.emit(events.DELETE_SKILL, this.gameId, skillId);
            this.configActive = 'NewSkill';
        },
        newRank: (newRank) => {
            _spinner('btn-newRank');
            this.socket.emit(events.NEW_RANK, this.gameId, newRank);
            this.configActive = 'NewRank';
        },
        manageRank: (rankId) => {
            this.socket.emit(events.MANAGE_RANK, this.gameId, rankId);
        },
        updateRank: (params, values) => {
            _spinner('btn-confirm-update-rank');
            this.socket.emit(events.EDIT_RANK, this.gameId, params, values);
        },
        deleteRank: (rankId) => {
            _spinner('btn-delete-rank');
            this.socket.emit(events.DELETE_RANK, this.gameId, rankId);
            this.configActive = 'NewRank';
        },
        newStatus: (newStatus) => {
            _spinner('btn-newStatus');
            this.socket.emit(events.NEW_STATUS, this.gameId, newStatus);
            this.configActive = 'NewStatus';
        },
        manageStatus: (statusId) => {
            this.socket.emit(events.MANAGE_STATUS, this.gameId, statusId);
        },
        updateStatus: (params, values) => {
            _spinner('btn-confirm-update-status');
            this.socket.emit(events.EDIT_STATUS, this.gameId, params, values);
        },
        deleteStatus: (statusId) => {
            _spinner('btn-delete-status');
            this.socket.emit(events.DELETE_STATUS, this.gameId, statusId);
            this.configActive = 'NewStatus';
        },
        newService: (serviceName) => {
            _spinner('btn-newService');
            this.socket.emit(events.NEW_SERVICE, this.gameId, serviceName);
            this.configActive = 'NewService';
        },
        manageService: (serviceId) => {
            this.socket.emit(events.MANAGE_SERVICE, this.gameId, serviceId);
        },
        updateService: (params, values) => {
            _spinner('btn-confirm-update-service');
            this.socket.emit(events.EDIT_SERVICE, this.gameId, params, values);
        },
        deleteService: (serviceId) => {
            _spinner('btn-delete-service');
            this.socket.emit(events.DELETE_SERVICE, this.gameId, serviceId);
            this.configActive = 'NewService';
        },
        /* Functions */
        newFunction: (newFunction) => {
            _spinner('btn-newFunction');
            this.socket.emit(events.NEW_FUNCTION, this.gameId, newFunction);
            this.configActive = 'NewFunction';
        },
        manageFunction: (functionId) => {
            this.socket.emit(events.MANAGE_FUNCTION, this.gameId, functionId);
        },
        updateFunction: (params, values) => {
            _spinner('btn-confirm-update-function');
            this.socket.emit(events.EDIT_FUNCTION, this.gameId, params, values);
        },
        deleteFunction: (functionId) => {
            _spinner('btn-delete-function');
            this.socket.emit(events.DELETE_FUNCTION, this.gameId, functionId);
            this.configActive = 'NewFunction';
        },
        addIncident: (incident) => {
            _spinner('btn-addIncident');
            this.socket.emit(events.ADD_INCIDENT, this.gameId, incident);
        },
        updateIncident: (params, values) => {
            _spinner(`btn-update-incident-${values[0]}`);
            this.socket.emit(events.EDIT_INCIDENT, this.gameId, params, values);
        },
        deleteIncident: (incident) => {
            _spinner(`btn-delete-incident-${incident}`);
            this.socket.emit(events.DELETE_INCIDENT, this.gameId, incident);
        },
        sigMap: (map, selectedGtaMap) => {
            this.socket.emit(events.SIG_MAP, this.gameId, map, selectedGtaMap);
        },
        sigAddDepartment: (department) => {
            this.socket.emit(events.SIG_ADD_DEPARTMENT, this.gameId, department);
        },
        sigRemoveDepartment: (department) => {
            this.socket.emit(events.SIG_REMOVE_DEPARTMENT, this.gameId, department);
        },
    };

    changeLocale = (locale) => {
        this.locale = locale;
        if (this.Bip) this.Bip.setLocale(locale);
        if (this.Radio) this.Radio.setLocale(locale);
    };

    waitForValidSession = () => {
        if (session && session.isValide) {
            this.session = session;
            this.waitForValidSocket();
        } else {
            setTimeout(() => this.waitForValidSession(), 100);
        }
    };

    waitForValidSocket = () => {
        if (socket && socket.connected) {
            this.socket = socket;
        } else {
            setTimeout(() => this.waitForValidSocket(), 100);
        }
    };

    init = (setUpdate, setData, setAlert) => {
        if (this.socket.connected && this.session && !this.isValide) {
            this.setUpdate = setUpdate;
            this.setData = setData;
            this.setAlert = setAlert;
            if (this.session.userName) {
                this.userName = this.session.userName;
                this.userId = this.session.userId;
                this.isValide = true;
                this.refreshList();
            }
        } else {
            setTimeout(() => this.init(setUpdate, setData, setAlert), 100);
        }
    };

    setPage = (page) => {
        this.page = page;
        this.update();
    };

    update = () => {
        if (!this.isValide) return;
        this.setUpdate(Math.round(Math.random() * 10));
    };

    refreshList = () => {
        if (!this.isValide) return;
        this.setPage('Logo');
        this.socket.emit(events.LOBBY, this.userName);
    };

    getAllGames = () => {
        this.socket.emit(events.LISTE_PARTIES);
    };

    createNewGame = () => {
        const gameName = _$('gameName').value;
        if (!gameName || gameName.lenght <= 3 || gameName.lenght > 25 || this.formatCharacter.test(gameName)) {
            _setText('informations', locales[this.locale].alerts.newGameRequiermentsForName);
            return NotificationManager.error(locales[this.locale].notifications.newGameNameInvalid, locales[this.locale].notifications.newGame, 3000);
        }
        _spinner('btn-createNewGame');
        this.socket.emit(events.NEW_GAME, gameName);
    };

    newGameNameUsed = () => {
        NotificationManager.error(locales[this.locale].notifications.newGameNameUsed, locales[this.locale].notifications.newGame, 3000);
        _$('btn-createNewGame').innerHTML = locales[this.locale].create;
        _$('btn-createNewGame').disabled = false;
    };

    newGameCreatedSuccess = (game) => {
        NotificationManager.success(locales[this.locale].notifications.newGameCreatedSuccess, locales[this.locale].game + ' ' + game.name, 3000);
        _setText('modalRp-body', locales[this.locale].alerts.newGameCreatedSuccess);
        _setText('modalRp-footer', '');
        setTimeout(() => {
            this.refreshList();
            _removeModals();
        }, 1500);
    };

    sendRequestJoin = (gameId) => {
        _spinner('btn-sendJoin-' + gameId);
        this.socket.emit(events.REQUEST_JOIN_GAME, gameId);
    };

    cancelRequestJoin = (gameId) => {
        _spinner('btn-cancelJoin-' + gameId);
        this.socket.emit(events.CANCEL_REQUEST_JOIN_GAME, gameId);
    };

    loadGame = (gameId) => {
        this.setPage('Logo');
        this.activeMission = null;
        this.socket.emit(events.LOAD_GAME, gameId || this.gameId);
    };

    startGame = (data, userId) => {
        this.setData(data);
        this.gameId = data.id;
        this.gameData = data;
        this.listStatus = data.status;
        this.userId = userId;
        this.setPage('GameHomePage');
        this.checkIsValid();
    };

    checkIsValid = () => {
        if (!this.gameId) {
            return document.location('/');
        }
        setTimeout(() => this.checkIsValid(), 10000);
    };

    configure = (gameId) => {
        this.setPage('Logo');
        this.socket.emit(events.CONFIGURE, gameId);
    };

    setConfiguration = (data, sigData) => {
        this.gameData = data;
        this.sigData = sigData;
        this.setData(data);
        this.setPage('Configuration');
    };

    shop = (gameId) => {
        this.setPage('Logo');
        this.socket.emit(events.SHOP, gameId);
    };

    setShop = (gameOptions, listOptions) => {
        this.setData({ gameOptions, listOptions: listOptions.listOptions, type: 'shop' });
        this.setPage('Shop');
    };

    buyOption = (optionId, selectedOption) => {
        _spinner('btn-buyOption-' + optionId);
        this.socket.emit(events.BUY_OPTION, this.gameId, optionId, selectedOption);
    };

    assignments = () => {
        this.setPage('Assignments');
        this.socket.emit(events.ASSIGNMENTS, this.gameId);
    };

    updatePlanning = (editPlanning, assignment, planningStatus, startPlanningTime, endPlanningTime) => {
        _spinner('btn-updatePlanning');
        this.socket.emit(events.UPDATE_PLANNING, this.gameId, editPlanning, assignment, planningStatus, startPlanningTime, endPlanningTime);
    };

    deletePlanning = (idPlanning, assignment) => {
        _spinner('btn-updatePlanning');
        this.socket.emit(events.DELETE_PLANNING, this.gameId, idPlanning, assignment);
    };

    sga = () => {
        this.setPage('Sga');
        this.socket.emit(events.SGA, this.gameId);
    };

    shareAlert = (alert, sgo) => {
        if (sgo) {
            _spinner('btn-engage');
            this.setPage('Sgo');
            this.socket.emit(events.NEW_ALERT, this.gameId, alert, sgo);
        } else {
            _spinner('btn-shareAndReturn');
            this.setPage('Sga');
            this.socket.emit(events.NEW_ALERT, this.gameId, alert);
        }
    };

    sgo = () => {
        this.setPage('Sgo');
        this.socket.emit(events.SGO, this.gameId);
    };

    addLogBook = (logBookEntries) => {
        this.socket.emit(events.ADD_LOGBOOK, this.gameId, logBookEntries);
    };

    closeMission = (missionId) => {
        this.socket.emit(events.CLOSE_MISSION, this.gameId, missionId);
    };

    proposeVehicles = (missionId) => {
        this.socket.emit(events.SELECT, this.gameId, missionId);
    };
    addToStart = (buildingId, vehicleId, missionId, functionName) => {
        this.socket.emit(events.ADD_TO_START, this.gameId, buildingId, vehicleId, missionId, functionName);
    };
    engage = (missionId) => {
        _spinner('btn-engage');
        this.socket.emit(events.ENGAGE, this.gameId, missionId);
    };
    changeStatusVehicle = (vehicleId, status) => {
        this.socket.emit(events.CHANGE_STATUS_VEHICLE, this.gameId, vehicleId, status);
    };
    removeVehicleMission = (vehicleId, reason) => {
        this.socket.emit(events.REMOVE_VEHICLE_MISSION, this.gameId, vehicleId, reason);
    };
    updateManning = (updateType, vehicleId, playerId, skill) => {
        this.socket.emit(events.UPDATE_MANNING, this.gameId, updateType, vehicleId, playerId, skill);
    };
    sendMessageToVehicle = (vehicleId, message) => {
        this.socket.emit(events.SEND_MESSAGE_TO_VEHICLE, this.gameId, vehicleId, message);
    };
    playAlarm = () => {
        this.alarm.play();
        this.alarm.loop = true;
    };
    acknowledgeNotification = (missionId, notificationId) => {
        this.socket.emit(events.ACKNOWLEDGE_NOTIFICATION, this.gameId, missionId, notificationId);
        this.alarm.pause();
    };

    // Bip
    allumerBip = () => {
        this.socket.emit(events.BIP_ON, this.gameId);
    };

    // Radio
    allumerRadio = (vehicleId) => {
        this.socket.emit(events.RADIO_ON, this.gameId, vehicleId);
    };
    radioSendStatus = (vehicleId, status) => {
        this.socket.emit(events.RADIO_SEND_STATUS, this.gameId, vehicleId, status);
    };

    // Ticket de départ
    impTicket = (missionId, vehicleId, buildingId, callback) => {
        this.socket.emit(events.IMP_TICKET, this.gameId, missionId, vehicleId, buildingId, callback);
        _spinner('btn-ticket');
    };
}
export default Module;
